// extracted by mini-css-extract-plugin
export default {"root_responsive":"SharingNewUnMount__root_responsive--22Jy_"};